import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Instance } from 'src/app/models/instance/instance';
import { Sandbox } from 'src/app/models/sandbox';
import { ServiceCardInfo } from 'src/app/models/service/service-card-info';
import { SolutionVersion } from 'src/app/models/service/solution-version';
import { toBoolean } from 'src/app/services/util/utils';
import {TenantDetails} from '../../../models/tenant-details';
import { Permission } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';

const REQUIRED_PERMISSIONS = [
  Permission.NO_SERVICES
];
@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: false
})
export class CardComponent implements OnInit {
  @Input() loader: boolean;
  @Input() sandboxCardInfo: ServiceCardInfo;
  @Input() serviceCardInfo: ServiceCardInfo;
  @Input() tenantDetails?: TenantDetails;
  @Input() serviceVersions: SolutionVersion;
  @Output() blueprintDeleted? = new EventEmitter<ServiceCardInfo>();

  isSandboxCard: boolean;
  sandbox: Sandbox;
  serviceDeleted = false;
  permissionsMap: {[key: string]: boolean};
  Permission = Permission;

  constructor(private permissionsService: PermissionsService) {
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveUserPermissions(REQUIRED_PERMISSIONS);

    if(this.loader && this.permissionsMap[Permission.NO_SERVICES]) {
      this.isSandboxCard = true;
    } else {
    this.isSandboxCard = this.isDemoBlueprint();

    if(this.isSandboxCard) {
      const demoInstance = this.getDemoInstance();
      this.sandbox = {
        service: this.serviceCardInfo.service,
        instance: demoInstance
      };
    }
  }
  }

  /**
   * Checks if the blueprint is demo blueprint
   *
   * @returns true if the blueprint is demo blueprint, false otherwise
   */
  isDemoBlueprint(): boolean {
    return toBoolean(this.serviceCardInfo?.blueprint?.demo);
  }

  /**
   * Finds the demo instance if present
   *
   * @returns the demo instance if found
   */
  getDemoInstance(): Instance {
    return this.serviceCardInfo?.instances?.find(instance => instance.blueprintId === this.serviceCardInfo?.blueprint?.id);
  }

  onBlueprintDeleted(cardInfo: ServiceCardInfo): void {
    this.blueprintDeleted.emit(cardInfo);
    this.serviceDeleted = true;
  }
}
